"use client"

import { Maybe } from "@instacover/utils"
import { AbstractIntlMessages, hasLocale, NextIntlClientProvider } from "next-intl"
import { NuqsAdapter } from "nuqs/adapters/next/app"
import { createContext, PropsWithChildren, useContext } from "react"

import { TrpcProvider } from "@/app/trpc"
import { routing } from "@/i18n"
import type { AuthSession } from "@/server/auth/auth"

const authSessionContext = createContext<{ authSession?: Maybe<AuthSession> }>({})

export function useAuthSession() {
  return useContext(authSessionContext)
}

type Props = {
  locale: string
  messages: AbstractIntlMessages
  authSession: Maybe<AuthSession>
  trpcStreamingDisabled?: boolean
}

export function GlobalProvider(props: PropsWithChildren<Props>) {
  const { children, messages, authSession, trpcStreamingDisabled } = props
  const locale = hasLocale(routing.locales, props.locale) ? props.locale : routing.defaultLocale

  return (
    <NuqsAdapter>
      <NextIntlClientProvider locale={locale} messages={messages} timeZone="Europe/Prague">
        <authSessionContext.Provider value={{ authSession }}>
          <TrpcProvider trpcStreamingDisabled={trpcStreamingDisabled}>{children}</TrpcProvider>
        </authSessionContext.Provider>
      </NextIntlClientProvider>
    </NuqsAdapter>
  )
}
